module.exports = __webpack_public_path__ + "static/media/one-logotype-light.356cc838.svg";